export const ActionTypes = {
  LOADING: "DELETE_CRITERIA_LOADING",
  ERROR: "DELETE_CRITERIA_ERROR",
  SUCCESS: "DELETE_CRITERIA_SUCCESS",
};
